import { useCallback, useState, useContext, useEffect } from "react";
import {
  addEmployeeRequestCategory,
  deleteEmployeeRequestCategory,
} from "../TicketManagement/TicketService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";

const EmployeeRequestCategory = () => {
  const [columns, setColumns] = useState(["Name", "Desc"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgDepartId, setOrgDepartId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
  const { GUID } = useParams();
  const [data, setData] = useState({
    Name: "",
    Desc: "",
  });

  useEffect(() => {
    getMasterTicketCategory();
  }, []);

  const validateOrgEmpRequestCategory = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-Name`] =
      !data.Name || data.Name.trim() === "" ? "Name  is required" : undefined;
    newErrors[`${index}-Desc`] =
      !data.Desc || data.Desc.trim() === "" ? "Desc is required" : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
      const firstCategory = data?.Data?.[0];
      if (firstCategory) {
        setSelectedCategoryId(firstCategory.Id);
      }
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setTicketCategoryType([...ticketCategoryType, { Name: "", Desc: "" }]);
    setEditIndex(ticketCategoryType.length); // enter edit mode for new row
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
    const { value } = e.target;
    setTicketCategoryType((prevList) => {
      const newList = prevList.map((item, idx) =>
        idx === rowIdx ? { ...item, [colName]: value } : item
      );
      return newList;
    });
    setData((prev) => ({ ...prev, [colName]: value }));
    validateOrgEmpRequestCategory(
      { ...ticketCategoryType[rowIdx], [colName]: value },
      rowIdx
    );
  };

  const cancelOrgWfh = () => {
    getMasterTicketCategory();
    setTicketCategoryType((prevList) => {
      setEditIndex(null);
      const len = prevList.length;
      if (len === 0) return prevList;
      const lastItem = prevList[len - 1];
      const isEmpty = lastItem && !lastItem.Name && !lastItem.Desc;
      if (isEmpty) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  };

  async function addOrgEmpReqCategory(index, data) {
    const body = {
      Id: data?.Id || 0,
      GUID: GUID,
      IsActive: true,
      OrgId: userDetails?.OrgId,
      Name: data.Name,
      Desc: data.Desc,
    };
    try {
      await addEmployeeRequestCategory(body);
      if (orgDepartId) {
        alert("Ticket Category Updated");
      } else {
        alert("Ticket Category Added");
      }
      setTicketCategoryType([]);
      setEditIndex(null);
      getMasterTicketCategory();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleDepartIstDelete = (Id) => {
    setOrgDepartId(Id);
  };

  async function DeleteOrgEmpRequestCategory() {
    setIsloading(true);
    if (orgDepartId) {
      let body = {
        Id: orgDepartId,
      };
      try {
        let orgDepartDeleteList = await deleteEmployeeRequestCategory(body);
        if (orgDepartDeleteList) {
          setIsloading(false);
          getMasterTicketCategory();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  let SearchValue = "";
  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = ticketCategoryType.filter((orgLoc) =>
        orgLoc.Name?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setTicketCategoryType(filteredList);
      } else {
        getMasterTicketCategory();
      }
    }, 800),
    [ticketCategoryType]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>Employee Request Category ({ticketCategoryType?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Category Request
              </button>
            )}
          </div>
        </div>

        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {ticketCategoryType?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.Name}
                          onChange={handleChange(index, "Name")}
                          placeholder="Name"
                          className={`form-control ${
                            errors[`${index}-Name`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Name`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Name`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <input
                          type="text"
                          value={data.Desc}
                          onChange={handleChange(index, "Desc")}
                          placeholder="Designation Desc"
                          className={`form-control ${
                            errors[`${index}-Desc`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Desc`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Desc`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                              if (validateOrgEmpRequestCategory(data, index)) {
                                addOrgEmpReqCategory(index, data);
                                setEditIndex(null);
                              }
                            }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.Name}</td>
                      <td>{data?.Desc}</td>

                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>

                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-emp-req-category"
                          onClick={() => {
                            handleDepartIstDelete(data?.Id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-emp-req-category">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>
                  Do you really want to delete this Employee Request Category?
                </p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgEmpRequestCategory()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeRequestCategory;
